import React, { useEffect, useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import { Container, Row, Col } from 'react-bootstrap';
import { FaPlus, FaTrash } from 'react-icons/fa';
import { Alert } from '../../../util/Alertas';
import { GetDataUser } from '../../../util/GetDataUser';

function ModalNovoCliente(props) {
    const [hora, setHora] = useState('');
    const [hora2, setHora2] = useState('');
    const usuario = GetDataUser();

    const { modalAberto, setModalAberto, setIsPessoaFisica,
        clienteData,
        setClienteData,
        handleSalvarCliente,
        InputMask,
        isPessoaFisica,
        horasSelecionados,
        sethorasSelecionados,
        diasSelecionados,
        setDiasSelecionados } = props;

    const onChangeTipoPessoa = (e) => {
        if (e.target.value == "0") {
            setIsPessoaFisica(true);
            setClienteData({
                ...clienteData,
                cpf: "",
                proprietario: "",
                dataCadastro: "",
                inscricaoEstadual: "",
                inscricaoMunicipal: "",
                responsavelCompra: "",
                responsavelCompraEmail: "",
                responsavelCompraTelefone: "",
                responsavelCompraTelefoneFixo: "",
                pessoaFisica: isPessoaFisica,
                segmentoCliente: "",
                origemCliente: "",
                origemIndicacao: "",
                origemCampanha: ""
            });
        } else {
            setIsPessoaFisica(false);
            setClienteData({
                ...clienteData,
                cnpj: "",
                email: "",
                telefone: "",
                responsavelCompra: "",
                responsavelCompraEmail: "",
                responsavelCompraTelefone: "",
                responsavelCompraTelefoneFixo: "",
                pessoaFisica: isPessoaFisica,
                segmentoCliente: "",
                origemCliente: "",
                origemIndicacao: "",
                origemCampanha: ""
            });
        }
    }

    const getLogadouro = (event) => {
        let cep = event.target.value;
        const url = `https://viacep.com.br/ws/${cep.replace('.', '').replace('.', '').replace('-', '')}/json/`;
        fetch(url)
            .then(response => {
                return response.json();
            })
            .then(data => {
                setClienteData({
                    ...clienteData,
                    cep: cep,
                    logradouro: data.logradouro,
                    bairro: data.bairro,
                    localidade: data.localidade,
                    uf: data.uf
                })
            }).catch(erro => console.log(erro))
    }

    const selecionaDia = (dia) => {
        setDiasSelecionados(prev =>
            prev.includes(dia)
                ? prev.filter(x => x !== dia)
                : [...prev, dia]
        );
    }

    const selecionaHora = () => {
        if (!hora) {
            Alert('Selecione um horario', false, true);
            return;
        }

        if (hora2) {
            let horario = `${hora} às ${hora2}`;
            if (horasSelecionados.includes(horario)) {
                setHora('');
                setHora2('');
                return;
            }
            sethorasSelecionados(prev => [...prev, horario]);
            return;
        }

        if (horasSelecionados.includes(hora)) {
            setHora('');
            return;
        }

        sethorasSelecionados(prev => [...prev, hora]);
        setHora('');
    }

    return (
        <Modal size='xl' show={modalAberto}>
            <Modal.Header style={{ flexDirection: 'column', gap: 0 }}>
                <h2 style={{ textAlign: 'center', width: '100%' }}>Formulário de {isPessoaFisica ? "Pessoa Física" : "Pessoa Jurídica"} </h2><br />
                <small style={{ textAlign: 'center', width: '100%', color: 'red' }}>Campos com "*" são obrigatórios!</small><br />
            </Modal.Header>
            <form onSubmit={e => { 
                e.preventDefault(); 
                
                // Validação de email e telefone
                if (clienteData.vendedorId) {
                    let vendedorSelecionado = props.vendedores.find(v => v.id == clienteData.vendedorId);
                    if (!vendedorSelecionado && usuario && !usuario.IsMaster) {
                         vendedorSelecionado = props.vendedores.find(v => v.id == usuario.UsuarioId) || props.vendedores.find(v => v.email == usuario.Email);
                    }
                    if (vendedorSelecionado) {
                        if (vendedorSelecionado.email === clienteData.email) {
                            Alert("O email do cliente não pode ser igual ao do vendedor.", false);
                            return;
                        }
                        if (vendedorSelecionado.telefone && vendedorSelecionado.telefone === clienteData.telefone) {
                            Alert("O telefone do cliente não pode ser igual ao do vendedor.", false);
                            return;
                        }
                    }
                }
                
                handleSalvarCliente() 
            }}>
                <Modal.Body>
                    <Container style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
                        {usuario.IsMaster && <Row>
                            <Col md={12}>
                                <label>Vendedor:</label>
                                <select value={clienteData.vendedorId} onChange={(e) =>
                                    setClienteData({ ...clienteData, vendedorId: e.target.value })
                                } className='form-control'>
                                    {props.vendedores.map(item => (
                                        <option value={item.id}>{item.nome}</option>
                                    ))}
                                </select>

                            </Col>
                            <Col md={12}>
                                <label>% Comissão:</label>
                                <input
                                    className='form-control'
                                    required
                                    type="number"
                                    min={1}
                                    max={100}
                                    id="comissao"
                                    value={clienteData.comissao}
                                    onChange={(e) =>
                                        setClienteData({ ...clienteData, comissao: e.target.value })
                                    }
                                    placeholder="% Comissão"
                                    maxLength={3}
                                />
                            </Col>
                        </Row>}
                        <Row>
                            <Col md={12}>
                                <label htmlFor="segmentoCliente">*Segmento do Cliente:</label>
                                <select 
                                    className='form-control' 
                                    required 
                                    value={clienteData.segmentoCliente} 
                                    onChange={(e) => setClienteData({...clienteData, segmentoCliente: e.target.value})}
                                >
                                    <option value="">Selecione</option>
                                    <option value="açougue">açougue</option>
                                    <option value="supermercado">supermercado</option>
                                    <option value="churrascaria-restaurante">churrascaria-restaurante</option>
                                    <option value="distribuidor">distribuidor</option>
                                    <option value="conveniência">conveniência</option>
                                    <option value="consumidor final">consumidor final</option>
                                </select>
                            </Col>
                        </Row>

                        {usuario.IsMaster && (
                            <Row>
                                <Col md={12}>
                                    <label htmlFor="origemCliente">*Origem do Cliente:</label>
                                    <select 
                                        className='form-control' 
                                        required 
                                        value={clienteData.origemCliente} 
                                        onChange={(e) => setClienteData({...clienteData, origemCliente: e.target.value})}
                                    >
                                        <option value="">Selecione</option>
                                        <option value="Indicação">Indicação</option>
                                        <option value="Prospecção ativa">Prospecção ativa</option>
                                        <option value="Anúncio (tráfego pago)">Anúncio (tráfego pago)</option>
                                        <option value="Instagram ou TikTok">Instagram ou TikTok</option>
                                        <option value="Google ou Maps">Google ou Maps</option>
                                        <option value="Viu nosso caminhão/logo na rua">Viu nosso caminhão/logo na rua</option>
                                        <option value="Cliente antigo que voltou">Cliente antigo que voltou</option>
                                        <option value="Não informado">Não informado</option>
                                    </select>
                                </Col>
                            </Row>
                        )}
                        
                        {usuario.IsMaster && clienteData.origemCliente === "Indicação" && (
                             <Row>
                                 <Col md={12}>
                                     <label htmlFor="origemIndicacao">*Quem indicou?</label>
                                     <input 
                                         className='form-control' 
                                         required 
                                         type="text" 
                                         value={clienteData.origemIndicacao} 
                                         onChange={(e) => setClienteData({...clienteData, origemIndicacao: e.target.value})}
                                     />
                                 </Col>
                             </Row>
                        )}

                        {usuario.IsMaster && clienteData.origemCliente === "Anúncio (tráfego pago)" && (
                             <Row>
                                 <Col md={12}>
                                     <label htmlFor="origemCampanha">Qual campanha?</label>
                                     <input 
                                         className='form-control' 
                                         type="text" 
                                         value={clienteData.origemCampanha} 
                                         onChange={(e) => setClienteData({...clienteData, origemCampanha: e.target.value})}
                                     />
                                 </Col>
                             </Row>
                        )}

                        <Row>
                            <Col md={12}>
                                <label htmlFor="nome">*Nome:</label>
                                <input
                                    className='form-control'
                                    required
                                    type="text"
                                    id="nome"
                                    value={clienteData.nome}
                                    onChange={(e) =>
                                        setClienteData({ ...clienteData, nome: e.target.value })
                                    }
                                    placeholder="Nome do Cliente"
                                    maxLength="100"
                                />
                            </Col>
                        </Row>
                        <Row>
                            <Col md={6}>
                                <label htmlFor="isPessoaFisica">*Tipo de Cliente:</label>
                                <select value={isPessoaFisica ? "0" : "1"} className='form-control' name="tipo" id="tipo" onChange={onChangeTipoPessoa}>
                                    <option value="0" selected>Pessoa Física</option>
                                    <option value="1">Pessoa Jurídica</option>
                                </select>
                            </Col>
                            <Col md={6}>
                                <label htmlFor="cnpjCpf">*{isPessoaFisica ? 'CPF' : 'CNPJ'}:</label>
                                <InputMask
                                    required
                                    className="form-control"
                                    mask={
                                        isPessoaFisica ? "999.999.999-99" : "99.999.999/9999-99"
                                    }
                                    value={isPessoaFisica ? clienteData.cpf : clienteData.cnpj}
                                    onChange={(e) => isPessoaFisica ?
                                        setClienteData({
                                            ...clienteData,
                                            cpf: e.target.value
                                        }) :
                                        setClienteData({
                                            ...clienteData,
                                            cnpj: e.target.value
                                        })
                                    }
                                    placeholder={isPessoaFisica ? "CPF" : "CNPJ"}
                                />
                            </Col>
                        </Row>
                        <Row>
                            <Col md={6}>
                                <label htmlFor="email">*Email:</label>
                                <input
                                    required
                                    className='form-control'
                                    type="email"
                                    id="email"
                                    value={clienteData.email}
                                    onChange={(e) =>
                                        setClienteData({ ...clienteData, email: e.target.value })
                                    }
                                    placeholder="E-mail"
                                    maxLength="254"
                                />
                            </Col>
                            <Col md={6}>
                                <label htmlFor="telefone">*Telefone:</label>
                                <InputMask
                                    required
                                    className="form-control"
                                    mask="(99) 99999-9999"
                                    value={clienteData.telefone}
                                    onChange={(e) =>
                                        setClienteData({
                                            ...clienteData,
                                            telefone: e.target.value,
                                        })
                                    }
                                    placeholder="Telefone"
                                />
                            </Col>
                        </Row>
                        <Row>
                            <Col md={12}>
                                <label htmlFor="responsavelCompra">
                                    Responsável pela Compra:
                                </label>
                                <input
                                    type="text"
                                    id="responsavelCompra"
                                    className="form-control"
                                    value={clienteData.responsavelCompra}
                                    onChange={(e) =>
                                        setClienteData({
                                            ...clienteData,
                                            responsavelCompra: e.target.value,
                                        })
                                    }
                                    placeholder="Responsável pela Compra"
                                />
                            </Col>
                        </Row>
                        <Row>
                            <Col md={12}>
                                <label htmlFor="responsavelCompraEmail">
                                    Email do Responsável pela Compra:
                                </label>
                                <input
                                    type="email"
                                    className="form-control"
                                    id="responsavelCompraEmail"
                                    value={clienteData.responsavelCompraEmail}
                                    onChange={(e) =>
                                        setClienteData({
                                            ...clienteData,
                                            responsavelCompraEmail: e.target.value,
                                        })
                                    }
                                    placeholder="E-mail do Responsável pela Compra"
                                    maxLength="254"
                                />
                            </Col>
                        </Row>
                        <Row>
                            <Col md={12}>
                                <label htmlFor="responsavelCompraTelefone">
                                    Telefone do Responsável pela Compra:
                                </label>
                                <InputMask
                                    className="form-control"
                                    mask="(99) 99999-9999"
                                    value={clienteData.responsavelCompraTelefone}
                                    onChange={(e) =>
                                        setClienteData({
                                            ...clienteData,
                                            responsavelCompraTelefone: e.target.value,
                                        })
                                    }
                                    placeholder="Telefone do Responsável pela Compra"
                                />
                            </Col>
                        </Row>
                        <Row>
                            <Col md={12}>
                                <label htmlFor="responsavelCompraTelefoneFixo">
                                    Telefone Fixo do Responsável pela Compra:
                                </label>
                                <InputMask
                                    mask="(99) 9999-9999"
                                    className="form-control"
                                    value={clienteData.responsavelCompraTelefoneFixo}
                                    onChange={(e) =>
                                        setClienteData({
                                            ...clienteData,
                                            responsavelCompraTelefoneFixo: e.target.value,
                                        })
                                    }
                                    placeholder="Telefone Fixo do Responsável pela Compra"
                                />
                            </Col>
                        </Row>
                        {!isPessoaFisica && <Row>
                            <Col md={12}>
                                <label htmlFor="proprietario">Proprietário:</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    id="proprietario"
                                    value={clienteData.proprietario}
                                    onChange={(e) =>
                                        setClienteData({
                                            ...clienteData,
                                            proprietario: e.target.value,
                                        })
                                    }
                                />
                            </Col>
                        </Row>}
                        {!isPessoaFisica && <Row>
                            <Col md={6}>
                                <label htmlFor="inscricaoEstadual">
                                    Inscrição Estadual:
                                </label>
                                <input
                                    className="form-control"
                                    type="text"
                                    id="inscricaoEstadual"
                                    value={clienteData.inscricaoEstadual}
                                    onChange={(e) =>
                                        setClienteData({
                                            ...clienteData,
                                            inscricaoEstadual: e.target.value,
                                        })
                                    } />
                            </Col>
                            <Col md={6}>
                                <label htmlFor="inscricaoMunicipal">
                                    Inscrição Municipal*:
                                </label>
                                <input
                                    required
                                    className="form-control"
                                    type="text"
                                    id="inscricaoMunicipal"
                                    value={clienteData.inscricaoMunicipal}
                                    onChange={(e) =>
                                        setClienteData({
                                            ...clienteData,
                                            inscricaoMunicipal: e.target.value,
                                        })
                                    }
                                />
                            </Col>
                        </Row>}
                        <Row>
                            <Col md={4}>
                                <label htmlFor="cep">*CEP:</label>
                                <InputMask
                                    required
                                    mask="99.999-999"
                                    className="form-control"
                                    value={clienteData.cep}
                                    onChange={(e) => {
                                        setClienteData({
                                            ...clienteData,
                                            cep: e.target.value,
                                        }); getLogadouro(e)
                                    }
                                    }
                                    placeholder="Cep"
                                />
                            </Col>
                            <Col md={8}>
                                <label htmlFor="logradouro">*Logradouro:</label>
                                <input
                                    required
                                    placeholder='logradouro'
                                    className="form-control"
                                    id="logradouro"
                                    value={clienteData.logradouro}
                                    onChange={(e) =>
                                        setClienteData({
                                            ...clienteData,
                                            logradouro: e.target.value,
                                        })
                                    }
                                />
                            </Col>
                        </Row>
                        <Row>
                            <Col md={3}>
                                <label htmlFor="numero">*Numero:</label>
                                <input
                                    className="form-control"
                                    id="numero"
                                    placeholder='Numero'
                                    value={clienteData.numero}
                                    onChange={(e) =>
                                        setClienteData({
                                            ...clienteData,
                                            numero: e.target.value,
                                        })
                                    }
                                />
                            </Col>
                            <Col md={6}>
                                <label htmlFor="localidade">*Localidade:</label>
                                <input
                                    required
                                    placeholder='localidade'
                                    className="form-control"
                                    id="localidade"
                                    value={clienteData.localidade}
                                    onChange={(e) =>
                                        setClienteData({
                                            ...clienteData,
                                            localidade: e.target.value,
                                        })
                                    }
                                />
                            </Col>
                            <Col md={3}>
                                <label htmlFor="uf">*Uf:</label>
                                <input
                                    required
                                    placeholder='Uf'
                                    className="form-control"
                                    id="uf"
                                    value={clienteData.uf}
                                    onChange={(e) =>
                                        setClienteData({
                                            ...clienteData,
                                            uf: e.target.value,
                                        })
                                    }
                                />
                            </Col>
                        </Row>
                        <Row>
                            <Col md={6}>
                                <label htmlFor="complemento">Complemento:</label>
                                <input
                                    className="form-control"
                                    id="complemento"
                                    placeholder='Complemento'
                                    value={clienteData.complemento}
                                    onChange={(e) =>
                                        setClienteData({
                                            ...clienteData,
                                            complemento: e.target.value,
                                        })
                                    }
                                ></input>
                            </Col>
                            <Col md={6}>
                                <label htmlFor="bairro">*Bairro:</label>
                                <input
                                    required
                                    className="form-control"
                                    id="bairro"
                                    placeholder='bairro'
                                    value={clienteData.bairro}
                                    onChange={(e) =>
                                        setClienteData({
                                            ...clienteData,
                                            bairro: e.target.value,
                                        })
                                    }
                                ></input>
                            </Col>
                        </Row>
                        <Row>
                            <Col md={12}>
                                <label htmlFor="">Dia da semana para entrega</label>
                                <Row>
                                    <Col md={2} ><input onClick={e => selecionaDia('Seg')} checked={diasSelecionados.includes('Seg')} type="checkbox" name="" id="" /> Seg</Col>
                                    <Col md={2} ><input onClick={e => selecionaDia('Ter')} checked={diasSelecionados.includes('Ter')} type="checkbox" name="" id="" /> Ter</Col>
                                    <Col md={2} ><input onClick={e => selecionaDia('Qua')} checked={diasSelecionados.includes('Qua')} type="checkbox" name="" id="" /> Qua</Col>
                                    <Col md={2}><input onClick={e => selecionaDia('Qui')} checked={diasSelecionados.includes('Qui')} type="checkbox" name="" id="" /> Qui</Col>
                                    <Col md={2}><input onClick={e => selecionaDia('Sex')} checked={diasSelecionados.includes('Sex')} type="checkbox" name="" id="" /> Sex</Col>
                                    <Col md={2}><input onClick={e => selecionaDia('Sab')} checked={diasSelecionados.includes('Sab')} type="checkbox" name="" id="" /> Sab</Col>
                                    <Col md={2}><input onClick={e => selecionaDia('Dom')} checked={diasSelecionados.includes('Dom')} type="checkbox" name="" id="" /> Dom</Col>
                                </Row>
                            </Col>
                            <br />
                            <br />
                            <Col md={12}>
                                <label htmlFor="">Horarios de entrega</label>
                                <div style={{ display: 'flex', justifyContent: "start", alignItems: 'center' }}>
                                    <div style={{ display: 'flex', width: '100%', alignItems: 'center' }}>
                                        <input value={hora} onChange={e => setHora(e.target.value)} type="time" className='form-control' />
                                        <span>às</span>
                                        <input value={hora2} onChange={e => setHora2(e.target.value)} type="time" className='form-control' />
                                    </div>
                                    <button type='button' onClick={selecionaHora} className='btn btn-primary'><FaPlus /></button>
                                </div>
                            </Col>
                            <Col md={12} >
                                <ul>
                                    {horasSelecionados.map(hora => (<li>{hora} <button type='button' onClick={e => sethorasSelecionados(horasSelecionados.filter(x => x !== hora))} className='btn'><FaTrash /></button></li>))}
                                </ul>
                            </Col>
                        </Row>
                        <Row>
                            <Col md={12}>
                                <label htmlFor="observacao">Observação:</label>
                                <textarea
                                    className="form-control"
                                    id="observacao"
                                    value={clienteData.observacao}
                                    onChange={(e) =>
                                        setClienteData({
                                            ...clienteData,
                                            observacao: e.target.value,
                                        })
                                    }
                                ></textarea>
                            </Col>
                        </Row>

                    </Container>
                </Modal.Body>
                <Modal.Footer style={{ display: 'flex', justifyContent: 'space-between' }}>
                    <button
                        className='btn btn-danger'
                        style={{ marginLeft: "10px" }}
                        type="button"
                        onClick={() => setModalAberto(false)}
                    >
                        Cancelar
                    </button>
                    <button disabled={diasSelecionados.length == 0 || horasSelecionados.length == 0} className='btn btn-primary' type='submit'>Salvar Cliente</button>
                </Modal.Footer>
            </form>
        </Modal >
    );
}

export default ModalNovoCliente;